import { CUSTOMER_CARD_STATUS } from "app/common/LocalConst";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import {
  pagingTreatmentPlanCard,
  getTreatmentPlanCardById,
  saveOrEditTreatmentPlanCard,
  deleteTreatmentPlanCard,
} from "app/services/TreatmentPlanCardService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

const DEFAULT_VALUE = {
  startDate: new Date(),
  cardStatus: CUSTOMER_CARD_STATUS[1].value,
  cardType: null,
  name: "",
  code: "",
  endDate: null,
  createPatient: true,
  patient: {
    displayName: "",
    birthDate: "",
    gender: "",
    phoneNumber: "",
  }
};

export default class TreatmentPlanCardStore {
  open = false;
  openInfoService = false;
  openConfirm = false;
  treatmentPlanCardPage = new PageResponse();
  searchPage = new SearchObject();
  documentData = null;
  selectValue = { ...DEFAULT_VALUE };

  constructor() {
    makeAutoObservable(this);
  }

  pagingTreatmentPlanCard = () => {
    pagingTreatmentPlanCard(this.searchPage)
      .then(({ data }) => {
        this.treatmentPlanCardPage = data || [];
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu không thành công");
      });
  };

  setOpenInfoService = (state) => {
    this.openInfoService = state;
  };

  handleChangeFormSearch = (searchPage) => {
    this.searchPage = { ...this.searchPage, ...searchPage };
    this.pagingTreatmentPlanCard();
  };

  handleGetById = async (id) => {
    try {
      const { data } = await getTreatmentPlanCardById(id);
      this.selectValue = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  handleOpenForm = async (id) => {
    if (Boolean(id)) {
      await this.handleGetById(id);
    }
    this.open = true;
  };

  handleEditForm = (obj) => {
    this.selectValue = obj;
    this.open = true;
  };

  handleCloseForm = () => {
    this.open = false;
    this.selectValue = { ...DEFAULT_VALUE };
    this.openConfirm = false;
  };

  saveOrEditTreatmentPlanCard = async (obj) => {
    let { patient, ...ortherData } = obj;
    if (patient) {
      ortherData.patientCode = patient?.code;
      ortherData.patientName = patient?.displayName;
      ortherData.patient = patient;
    }

    try {
      const { data } = await saveOrEditTreatmentPlanCard(ortherData);
      this.pagingTreatmentPlanCard();
      this.handleCloseForm();
      toast.success("Lưu thành công");
    } catch (error) {
      console.log(error);
      toast.error("Lưu thất bại!!");
    }
  };

  handleOpenConfirm = (id) => {
    this.openConfirm = id;
  };

  handleRemoveTreatmentPlanCard = async () => {
    deleteTreatmentPlanCard(this.openConfirm)
      .then(() => {
        toast.success("Xóa thành công");
        this.pagingTreatmentPlanCard();
      })
      .catch(() => {
        toast.error("Xóa thất bại");
      })
      .finally(() => {
        this.handleCloseForm();
      });
  };

  resetStore = () => {
    this.treatmentPlanCardPage = new PageResponse();
    this.searchPage = new SearchObject();
    this.open = false;
    this.openConfirm = false;
    this.selectValue = { ...DEFAULT_VALUE };
  };
}
